// Phase 36 — Friendly-label maps for master-admin UI.
//
// Raw enum values (from the backend) stay in the DOM via `data-*`
// attributes so Playwright / tests / CSS can select on them. The
// visible text is the friendly label mapped below. No translation
// framework — literal strings only.
//
// Keep in sync with:
//   * backend/app/password_reset_pipeline.py (outcome / error_category)
//   * backend/app/routers/master_tenant_detail.py (attribution / integration enum)

export const OUTCOME_LABEL = {
  provider_accepted: "Accepted for sending",
  provider_failed: "Send failed",
  account_not_found: "Account not found",
  native_login_disabled: "Native login disabled",
  disabled_account: "Account disabled",
  duplicate_identity_rejected: "Duplicate identity rejected",
  identity_integrity_error: "Account needs attention",
  action_needed: "Action needed",
  rate_limited: "Rate limited",
};

export const ACTOR_SCOPE_LABEL = {
  public: "Sign-in page",
  master_triggered: "Master admin",
};

export const ERROR_CATEGORY_LABEL = {
  rate_limit: "Rate limit",
  domain_unverified: "Domain unverified",
  transport: "Transport error",
  config: "Configuration",
  authentication_failed: "Authentication failed",
  duplicate_identity: "Duplicate identity",
  dangling_identity_pointer: "Identity integrity",
  legacy_user_needs_identity_materialization: "Legacy account",
  not_applicable: "Not applicable",
  other: "Other",
};

export function outcomeLabel(raw) {
  if (!raw) return "—";
  return OUTCOME_LABEL[raw] || raw;
}

export function actorScopeLabel(raw) {
  if (!raw) return "—";
  return ACTOR_SCOPE_LABEL[raw] || raw;
}

export function errorCategoryLabel(raw) {
  if (!raw) return "—";
  return ERROR_CATEGORY_LABEL[raw] || raw;
}
